export function coordinates(value) {
  const point = value?.coordinate || value;
  if (!Array.isArray(point) || point.length < 2 || point.slice(0, 2).some(v => v == null || v === "")) return;
  const [longitude, latitude] = point.map(Number);
  if (!Number.isFinite(longitude) || !Number.isFinite(latitude) || Math.abs(longitude) > 180 || Math.abs(latitude) > 90) return;
  return [longitude, latitude];
}

export async function weatherRequest({ point, apiKey, signal, fetch = globalThis.fetch }) {
  const location = coordinates(point);
  if (!location) throw new Error("Weather needs a valid location.");
  const url = new URL("https://api.openweathermap.org/data/2.5/weather");
  url.search = new URLSearchParams({ lat: location[1], lon: location[0], units: "metric", appid: apiKey });
  const response = await fetch(url, { signal });
  const data = await response.json();
  if (!response.ok || !data.main) throw new Error(data.message || `Weather request failed (${response.status}).`);
  return data;
}
